export default "__VITE_ASSET__2c6cad48__"